// import axios from "axios";
// import { LocalStore } from "../storage/authStore";
// import { useLocation } from "react-router-dom";

// export const commonRequest = async(methods, url, body, token=0) => {
//     let header = {};
//     // Check if the body is FormData
//     const isFormData = body instanceof FormData;

//     if (isFormData) {
//         header = {
//             "Content-Type": "multipart/form-data"
//         };
//     } else {
//         header = {
//             "Content-Type": "application/json"
//         };
//     }
//     if(token){
//         header.Authorization = `Bearer ${token}`;
//     }
//     let config = {
//         method: methods,
//         url,
//         headers: header,
//         data: body
//     }
    
//     // axios instance
//     return axios(config).then((data) => {
//         if(data.data.success===0){
//             if(data.data.message==="Invalid Token"){
//                 LocalStore.doLogout();
//             }
//             if(data.data.message==="Token is expired"){
//                 LocalStore.doLogout();
//             }
//         }
//         return data.data;
//     }).catch((error)=>{
//         if(error.response){
//             if(error.response.data.message==="Invalid Token"){
//                 LocalStore.doLogout();
//             }
//             if(error.response.data.message==="Token is expired"){
//                 LocalStore.doLogout();
//             }
//             return error.response.data;
//         }
//         return error.message
//     })
// }

import axios from "axios";
import { LocalStore } from "../storage/authStore";
import Swal from "sweetalert2";

const withHttpMeta = (payload, response) => {
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return payload;
    const result = { ...payload };
    Object.defineProperty(result, "_http", {
        configurable: false,
        enumerable: false,
        value: {
            status: response?.status || null,
            retryAfter: response?.headers?.["retry-after"] || response?.headers?.get?.("retry-after") || null,
        },
    });
    return result;
};

export const commonRequest = async (methods, url, body, token = 0, progressCallback = null, extraHeaders = {}, options = {}) => {
    let header = {};
    const isFormData = body instanceof FormData;

    if (isFormData) {
        header = {
            "Content-Type": "multipart/form-data"
        };
    } else {
        header = {
            "Content-Type": "application/json"
        };
    }
    if (token) {
        header.Authorization = `Bearer ${token}`;
    }
    header = { ...header, ...extraHeaders };

    let config = {
        method: methods,
        url,
        headers: header,
        data: body
    };

    if (progressCallback && isFormData) {
        config.onUploadProgress = (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCallback(percentCompleted);
        };
    }

    return axios(config)
        .then((data) => {
            if (data.data.success === 0) {
                if (data.data.message === "Invalid Token" || data.data.message === "Token is expired") {
                    const currentUrl = window.location.pathname + window.location.search;
                    localStorage.setItem("lastVisitedUrl", currentUrl);
                    LocalStore.doLogout();
                }else if (!options.inlineErrors){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: data.data.message,
                        confirmButtonText: 'OK'
                    });
                }
            }
            return withHttpMeta(data.data, data);
        })
        .catch((error) => {
             // Network connectivity error handling
        if (error.code === 'ECONNABORTED') {
            // Optional sections render transport failures inline without blocking the page.
            if (!options.inlineErrors) Swal.fire({
                icon: 'error',
                title: 'Request Timeout',
                text: 'The request took too long. Please check your internet connection.',
                confirmButtonText: 'OK'
            });

            return {
                success:0,
                message:'The request took too long. Please check your internet connection.'
            }
        }
         else if (error.code === 'ERR_NETWORK') {
            // No internet connection or server unreachable
            if (!options.inlineErrors) Swal.fire({
                icon: 'error',
                title: 'Network Error',
                text: 'Unable to connect to the server. Please check your internet connection.',
                confirmButtonText: 'OK',
                // showCancelButton: true,
                // cancelButtonText: 'Close'
            });
            return {
                success:0,
                message:'Unable to connect to the server. Please check your internet connection.'
            }
        } 
        else if (error.response) {
            // Token-related errors
            if (error.response.data.message === "Invalid token" || error.response.data.message === "Token is expired") {
                
                
                Swal.fire({
                    icon: 'warning',
                    title: 'Session Expired',
                    text: 'Your session has expired. Please log in again.',
                    confirmButtonText: 'OK',
                    //outside click disable
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const currentUrl = window.location.pathname + window.location.search;
                        const loggedUserDetails =LocalStore.getCurrentUserDetails();
                        // logged user id and last visited url store in local storage
                        const lastLoggedDetails = {
                            id:loggedUserDetails.id,
                            role:loggedUserDetails.role,
                            lastVisitedUrl: currentUrl
                        }

                        localStorage.setItem("lastVisitedInfo", JSON.stringify(lastLoggedDetails));
                        LocalStore.doLogout();
                    }
                });
                return withHttpMeta(error.response.data, error.response);
            }
            else if (error.response?.statusText === "Bad Request") {
                // Swal.fire({
                //     icon: 'error',
                //     title: 'Unauthorized',
                //     text: 'You are not authorized to access this resource.',
                //     confirmButtonText: 'OK'
                // });
                return withHttpMeta(error.response.data, error.response);
            }
            
            return withHttpMeta(error.response.data, error.response);
        }
        
        // // For any other errors, return the error message
        else{
            if (!options.inlineErrors) Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message,
                confirmButtonText: 'OK'
            });
             return {
                success:0,
                message:error.message
            }
        }
        
    });
};
